import { gql } from "graphql-tag"

const typeCustomerPrice = gql`
  type CustomerPrice {
    type: String
    price: Float
  }
`

export { typeCustomerPrice }

export default typeCustomerPrice
